export default "__VITE_ASSET__DL3wX4Y5__"